exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.handing-all-btn[data-v-695b5c51]{\n  margin-left:20px;\n  margin-top:20px;\n}\n.handing-table[data-v-695b5c51]{\n  margin-top: 40px;\n}\n", ""]);

// exports
